(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('age-gate');
    if (!el) {
      console.log('Age Gate: no #age-gate element found');
      return;
    }
    console.log('Age Gate: element found');

    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var key = el.dataset.key || 'ageVerified';
    var days = parseInt(el.dataset.rememberDays || el.dataset.remember_days || '1', 10);
    var redirect = el.dataset.redirectUrl || el.dataset.redirect_url || '/';

    // getStored: supports expiry-stored localStorage, or 'true' legacy, or cookie fallback
    function getStored() {
      try {
        var val = localStorage.getItem(key);
        if (val) {
          var num = Number(val);
          if (!isNaN(num)) {
            if (num > Date.now()) return true;
            // expired → cleanup
            localStorage.removeItem(key);
          } else if (val === 'true') {
            // legacy accept
            return true;
          }
        }
      } catch (e) {
        console.warn('Age Gate getStored localStorage error', e);
      }

      // cookie fallback: presence of cookie means it was set and will expire server-side
      try {
        var m = document.cookie.match(new RegExp('(^|;)\\s*' + key + '=([^;]+)'));
        if (m && m[2]) {
          return true;
        }
      } catch (e) {
        console.warn('Age Gate cookie check error', e);
      }
      return false;
    }

    // store: store expiry timestamp in localStorage (so we can respect remember_days), also set cookie for compatibility
    function store() {
      try {
        var expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
        localStorage.setItem(key, String(expiresAt));
        var d = new Date(expiresAt);
        document.cookie = key + '=true; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
      } catch (e) {
        console.warn('Age Gate store error', e);
      }
    }

    if (!inEditor && getStored()) {
      console.log('Age Gate: already accepted, skipping display');
      return;
    }

    // elements
    var backdrop = el.querySelector('.age-gate__backdrop');
    var modal = el.querySelector('.age-gate__modal');
    var yesBtn = el.querySelector('.age-gate__btn--yes');
    var noBtn = el.querySelector('.age-gate__btn--no');

    // show modal + backdrop
    el.classList.remove('age-gate--hidden');
    if (backdrop) backdrop.classList.remove('age-gate--hidden');
    document.documentElement.classList.add('age-gate-open');
    document.body.classList.add('age-gate-open');

    // helper to close (unfreeze page, remove element after short delay so animations can run)
    function closeModal() {
      document.documentElement.classList.remove('age-gate-open');
      document.body.classList.remove('age-gate-open');

      // hide visually
      el.classList.add('age-gate--hidden');
      if (backdrop) backdrop.classList.add('age-gate--hidden');

      // remove from DOM after 300ms
      setTimeout(function () {
        try { if (el && el.parentNode) el.parentNode.removeChild(el); } catch (e) {}
      }, 320);
    }

    if (yesBtn) {
      yesBtn.addEventListener('click', function (ev) {
        ev && ev.preventDefault();
        store();
        closeModal();
        console.log('Age Gate: accepted — stored and closed');
      });
    }

    if (noBtn) {
      noBtn.addEventListener('click', function (ev) {
        ev && ev.preventDefault();
        var url = noBtn.dataset.redirect || redirect || '/';
        console.log('Age Gate: redirecting to', url);
        // close UI then redirect (small delay to ensure classes removed)
        closeModal();
        setTimeout(function () { window.location.href = url; }, 60);
      });
    }

    // Optional: allow ESC to close? Usually not for age gates (keeps it required).
    // Focus trapping (simple)
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = el.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
      focusables = Array.prototype.slice.call(focusables);
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });

    // focus primary button
    if (yesBtn) yesBtn.focus();
  });

  console.log('Age Gate: script loaded');
})();
